export default __webpack_public_path__ + "static/media/PTSans-Bold.610bc32a.ttf";